var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 369,
    viewBox: "0 0 327 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.093 205.81L245.307 205.81L245.307 287.496L163.387 287.496L163.387 263.285C163.387 231.38 189.185 205.81 221.093 205.81Z",
    fill: "#00B1BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.201 83.1687L122.201 123.898C99.5708 123.898 81.2407 105.57 81.2407 82.9424L122.201 82.9424",
    fill: "#F36B36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79024e-06 0.579178L40.9598 0.57918C40.9598 23.2068 22.6297 41.5352 0 41.5352L1.79024e-06 0.579178Z",
    fill: "#3F2E7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.161 83.1719L122.201 83.1719C122.201 60.5442 140.531 42.2159 163.161 42.2159L163.161 83.1719Z",
    fill: "#F04956"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.161 246.547L122.201 246.547C122.201 223.919 140.531 205.591 163.161 205.591L163.161 246.547Z",
    fill: "#F04956"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M327 246.54C327 223.921 308.661 205.584 286.04 205.584C263.418 205.584 245.08 223.921 245.08 246.54C245.08 269.159 263.418 287.496 286.04 287.496C308.661 287.496 327 269.159 327 246.54Z",
    fill: "#F99D2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.347 83.1729C226.977 83.1729 245.307 101.501 245.307 124.129L163.387 124.129C163.387 101.501 181.717 83.1729 204.347 83.1729Z",
    fill: "#3F2E7F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.96 82.4929C40.96 59.8653 59.2901 41.5369 81.9198 41.5369L81.9198 123.223C59.0638 123.223 40.96 104.894 40.96 82.4929Z",
    fill: "#00B1BF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.347 307.862C204.347 296.615 195.228 287.497 183.98 287.497C172.732 287.497 163.613 296.615 163.613 307.862C163.613 319.109 172.732 328.227 183.98 328.227C195.228 328.227 204.347 319.109 204.347 307.862Z",
    fill: "#F99D2D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9197 164.403C81.9197 141.784 63.5814 123.447 40.9599 123.447C18.3384 123.447 2.77897e-06 141.784 1.79024e-06 164.403C8.01519e-07 187.023 18.3383 205.359 40.9598 205.359C63.5813 205.359 81.9197 187.023 81.9197 164.403Z",
    fill: "#F04956"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M245.08 307.862C245.08 296.615 235.962 287.497 224.713 287.497C213.465 287.497 204.347 296.615 204.347 307.862C204.347 319.109 213.465 328.227 224.713 328.227C235.962 328.227 245.08 319.109 245.08 307.862Z",
    fill: "#F04956"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3263 164.401C61.3263 153.154 52.2078 144.036 40.9595 144.036C29.7113 144.036 20.5928 153.154 20.5928 164.401C20.5928 175.648 29.7113 184.766 40.9595 184.766C52.2078 184.766 61.3263 175.648 61.3263 164.401Z",
    fill: "#101940"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.08 348.819C245.08 337.572 235.962 328.454 224.713 328.454C213.465 328.454 204.347 337.572 204.347 348.819C204.347 360.066 213.465 369.184 224.713 369.184C235.962 369.184 245.08 360.066 245.08 348.819Z",
    fill: "#00B1BF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M204.347 348.819C204.347 337.572 195.228 328.454 183.98 328.454C172.732 328.454 163.613 337.572 163.613 348.819C163.613 360.066 172.732 369.184 183.98 369.184C195.228 369.184 204.347 360.066 204.347 348.819Z",
    fill: "#3F2E7F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.387 205.812L163.387 123.901L204.347 164.857L163.387 205.812Z",
    fill: "#F99D2D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.387 287.496L81.6934 287.496L81.6934 205.81L163.387 287.496Z",
    fill: "#F36B36"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6935 232.964L81.6935 287.496L27.1558 287.496L81.6935 232.964Z",
    fill: "#3F2E7F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5377 205.815L54.5377 260.121L0 260.121L54.5377 205.815Z",
    fill: "#3F2E7F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5706e-06 287.498L81.6934 287.498L81.6934 369.184L3.5706e-06 287.498Z",
    fill: "#F99D2D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8555 302.659L96.8555 354.023L148.225 354.023L148.225 302.659L96.8555 302.659Z",
    fill: "#F04956"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46385e-06 335.468L0 368.957L33.492 368.957L33.492 335.468L1.46385e-06 335.468Z",
    fill: "#3F2E7F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M245.114 124.145L204.31 164.945L245.114 205.745L285.918 164.945L245.114 124.145Z",
    fill: "#F04956"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M327 369.184L245.307 369.184L286.04 328.228L327 369.184Z",
    fill: "#3F2E7F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M245.307 287.497L326.774 287.497L286.04 328.227L245.307 287.497Z",
    fill: "#F04956"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.55 123.901L126.501 205.813L139.626 205.813L117.901 123.901L104.55 123.901Z",
    fill: "#00B1BF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M128.537 123.901L150.262 205.813L163.613 205.813L141.662 123.901L128.537 123.901Z",
    fill: "#00B1BF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2407 123.901L103.192 205.813L116.317 205.813L94.366 123.901L81.2407 123.901Z",
    fill: "#00B1BF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M229.013 148.791L229.013 181.148L261.374 181.148L261.374 148.791L229.013 148.791Z",
    fill: "#101940"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54092e-06 42.2158L0 123.223L40.9598 123.223L40.9599 42.2158L3.54092e-06 42.2158Z",
    fill: "#F99D2D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColors);
export default __webpack_public_path__ + "static/media/colors.413061714703437f882ba6578a199832.svg";
export { ForwardRef as ReactComponent };